import { createSlice } from '@reduxjs/toolkit'
import { ApplicationsState } from './types'

const initialState: ApplicationsState = {
  applicationsSelectedRange: {
    from: '',
    to: '',
  },
  applicationsArchiveSelectedRange: {
    from: '',
    to: '',
  },
}

export const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setApplicationsSelectedRange(state, action) {
      state.applicationsSelectedRange = action.payload
    },
    setApplicationsArchiveSelectedRange(state, action) {
      state.applicationsArchiveSelectedRange = action.payload
    },
  },
})

export const applicationsReducer = applicationsSlice.reducer
export const {
  setApplicationsSelectedRange,
  setApplicationsArchiveSelectedRange,
} = applicationsSlice.actions
